import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Alert, AlertTitle, Button } from '@mui/material';
import Cookies from 'js-cookie';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useQuery } from '@apollo/client';
import { styled } from '@mui/material/styles';
import Page from '../components/Page';
import { GET_USER_STATUS } from '../graphql';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

const Processing = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestid');
  const mfilterId = queryParams.get('mfilter_id');

  const [open, setOpen] = React.useState(false);
  const [stopFetching, setStopFetching] = React.useState(true);
  const [message, setMessage] = React.useState('');

  const handleClose = () => {
    setOpen(false);
    if (message === 'Success') {
      navigate('/app/games');
    } else if (message === 'Failure') {
      navigate('/logout');
    } else {
      navigate('/app/games'); // fallback
    }
  };

  // const fetchCallbackData = async () => {
  //   let attempts = 0;
  //   let responseData = null;

  //   while (attempts < 3) {
  //     try {
  //       const url = `http://localhost:3005/cornfirming/latest`;
  //       const response = await fetch(url);
  //       responseData = await response.json();

  //       if (responseData && Object.keys(responseData).length !== 0) {
  //         console.log('Received data:', responseData.message);
  //         setMessage(responseData.message);
  //         break;
  //       }
  //     } catch (err) {
  //       console.error('Fetch error:', err);
  //     }

  //     attempts++;
  //     await new Promise(resolve => setTimeout(resolve, 1000));
  //   }

  //   if (!responseData || Object.keys(responseData).length === 0) {
  //     setOpen(false);
  //     navigate('/app/games');
  //   }
  // };
  const fetchCallbackData = async () => {
    // Extract query parameters from current window location
    const queryParams = new URLSearchParams(window.location.search);
    const requestid = queryParams.get('requestid');
    const mfilter_id = queryParams.get('mfilter_id');
    const msisdn = queryParams.get('msisdn');
    const message = queryParams.get('message');
    const error = queryParams.get('error');
    const advertiser_id= queryParams.get('advertiser_id');

  
    console.log('Extracted data:', {
      requestid,
      mfilter_id,
      msisdn,
      advertiser_id,
      message,
      error,
    });
  
    if (message) {
      setMessage(message);
      await new Promise(resolve => setTimeout(resolve, 5000));

      if (message === 'Success') {
        navigate('/app/games');
      } else {
        navigate('/open/games');
      }
    } else {
      setOpen(false);
      navigate('/app/games');
    }
  };
  

  // Only call once when component mounts
  useEffect(() => {
    setOpen(true);
    fetchCallbackData();
  }, []);

  const { error, data, loading } = useQuery(GET_USER_STATUS, {
    pollInterval: 5000
  });

  useEffect(() => {
    const msisdn = Cookies.get('msisdn');
    if (!msisdn) {
      navigate('/subscribe');
    }

    if (data && data.getUserStatus) {
      const { responseCode, msisdn } = data.getUserStatus;

      if (responseCode === 200) {
        setOpen(true);
      } else if (responseCode === 204) {
        navigate('/open/games');
      } else if (responseCode === 300) {
        localStorage.setItem('msisdn', msisdn);
        localStorage.setItem('subscribed', '');
        localStorage.setItem('newUser', 'newUser');
        navigate('/open/games');
      } else {
        setTimeout(() => {
          setStopFetching(false);
          navigate('/subscribe');
        }, 1800000); // 30 minutes
      }
    }
  }, [data, navigate]);

  return (
    <Page title="Processing | ZetuPlay">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4
          }}
        >
          <Typography id="modal-modal-title" variant="h5" component="h5" sx={{ paddingBottom: '5px' }}>
            {message === 'Success' ? 'Congratulations' : 'Notice'}
          </Typography>
          <Typography id="modal-modal-description" variant="body1">
            {message ? `Message: ${message}` : 'Message: Please confirm'}
          </Typography>

          <Button onClick={handleClose} sx={{ marginTop: '30px' }}>
            Ok
          </Button>
        </Box>
      </Modal>

      <Container maxWidth="xl">
        <ContentStyle>
          {(loading || stopFetching) && (
            <Alert severity="info">
              <AlertTitle>Please wait...</AlertTitle>
              We are processing your request.
            </Alert>
          )}
          {error && (
            <Alert severity="error">There was an error subscribing. Please try again later.</Alert>
          )}
        </ContentStyle>
      </Container>
    </Page>
  );
};

export default Processing;
